export class KeyValue {

	public key: string;

	public value: string;

}
